










import { Component, Vue } from 'vue-property-decorator';
import { State, Action, Mutation } from 'vuex-class';
import Header from './components/Header.vue';
import Footer from '@/components/Footer.vue';
import api from '@/api';
import store from '@/store.ts';

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class App extends Vue {
  @State public headerVisibility!: boolean;
  @Action public OPEN_SOCKET: any;

  private async mounted() {
    this.OPEN_SOCKET();
  }
}
